<template>
  <div class="nutrition">
      <div v-if="stream && stream.id > 0">
          <div style="position: fixed; top: 0; left: 0; width: 100%; z-index: 9">
            <v-container justify-center>
            <v-flex class="xs12 sm6 lg4 mx-auto week-header" justify-center>
              <v-layout class="mx-2">
                <div style="width: 100%;">
                  <v-layout align-center justify-space-between class="week-nav">
                    <v-btn :disabled="selectedWeek <= 1" text class="pl-0" @click="Math.max(challengeWeek - 1, selectedWeek--)"><v-icon>chevron_left</v-icon>Prev</v-btn>
                    <h3 v-if="$vuetify.breakpoint.width >= 375">{{ selectedWeek | weekName(realWeek, realDay) }}</h3>
                    <h3 v-if="$vuetify.breakpoint.width < 375">Wk {{ selectedWeek | leadingZero }}</h3>
                    <v-btn :disabled="selectedWeek >= Math.min(weeks, challengeWeek + 1) && !user.isAdmin" text class="pr-0" @click="Math.min(Math.min(weeks, challengeWeek + 1), selectedWeek++)">Next<v-icon>chevron_right</v-icon></v-btn>
                  </v-layout>
                  <v-layout align-center justify-center style="" class="token-container mb-3" >
                    <v-btn v-for="token in tokens"
                            dark
                            color="red"
                            small
                           class="mx-2"
                            :class="{'v-btn--active': token.item}"
                           @click="show_tokens = true"
                           :disabled="selectedWeek !== currentWeek"
                    >
                      <span v-if="$vuetify.breakpoint.width >= 425">{{ token.type }}</span>
                      <span v-if="$vuetify.breakpoint.width < 425">{{ token.type | truncated }}</span>
                      <v-icon right dark>{{ mdiTicket }}</v-icon>
                    </v-btn>
                  </v-layout>
                  <v-layout align-center justify-space-between>
                    <v-btn @click="update_stream = true" color="primary" small dark tile>{{ stream.title }} <v-icon small class="ml-3">edit</v-icon></v-btn>
                    <v-btn v-if="$vuetify.breakpoint.width >= 375 && currentDay >= 0" text @click="goToday" style="margin: 0; min-width: 20px; ">Today</v-btn>
                    <v-btn class="ma-0" text color="primary" small light :to="'/nutrition/shopping-list/' + selectedWeek"><v-icon class="mr-1">list</v-icon>Shopping List</v-btn>
                  </v-layout>
                </div>
              </v-layout>
            </v-flex>
            </v-container>
          </div>
          <div>
            <meal-plan v-if="!loading" :challengeWeek="currentWeek" :realDay="realDay"></meal-plan>
          </div>
    </div>
    <v-dialog v-model="show_tokens" max-width="500px">
      <v-card>
        <v-card-title class="headline">Meal Tokens</v-card-title>
        <v-card-text>
          <p>Each week you receive 2 meal tokens, and 2 snack/alcohol tokens. which will help you follow the 90/10 rule. Read more about your Tokens in 'Advice'.</p>
          <p>Hit the <v-icon>mdi-ticket</v-icon> icon next to each meal to claim or disclaim.</p>
          <h3>Your tokens this week</h3>
          <div>
            <v-list>
              <template v-for="(t, index) in tokens">
                <v-list-item
                        :key="index"
                        @click="(t.item) ? disclaimToken(t.item) : null"
                >
                  <v-list-item-icon>
                    <v-icon class="token-color" :class="{'token-claimed': (t.item)}">mdi-ticket</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title v-html="t.type"></v-list-item-title>
                    <v-list-item-subtitle><span v-if="t.item">{{ getTokenDetails(t) }}</span><span v-if="!t.item">Unclaimed</span></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="show_tokens = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="update_stream" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Select Your Stream</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-radio-group v-model="stream">
                <v-radio
                        v-for="stream in streams"
                        :key="stream.id"
                        :label="stream.title"
                        :value="stream"
                ></v-radio>
              </v-radio-group>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="stream" color="blue darken-1" text @click="update_stream = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment'
  import MealPlan from "../plugins/bft-nutrition-plugin/components/MealPlan";
  import { mdiTicket } from '@mdi/js';

  export default {
    components: {MealPlan},
      created() {
          this.unwatch = this.$store.watch(
              (state, getters) => getters['Global/loading'],
              (newValue, oldValue) => {
                  if(!newValue && this.goto === true) {
                      setTimeout(() => this.$vuetify.goTo('.today', {offset: 30 + 83}), 500)
                      this.goto = false
                  }
              }
          )
      },
      beforeDestroy() {
          this.unwatch()
      },
    mounted () {
      if(!this.stream || this.stream.id < 1) {
        this.update_stream = true
      } else if(this.stream.id > 0 && (!this.meal_plan_items || this.meal_plan_items.length < 1)) {
          this.$store.dispatch('nutrition/loadNutritionData')
      }

    },
    computed: {
      stream: {
        async set (stream) {
            this.$store.dispatch('nutrition/setMemberStream', stream)
            this.update_stream = false
        },
        get () {
          return this.$store.getters['Streams/stream']
        }
      },
      selectedWeek: {
        set (week) {
            if(week === this.selectedWeek) return
          this.$store.dispatch('nutrition/setWeek', week)
        },
        get () {
          return this.$store.state.nutrition.selectedWeek
        }
      },
        token: {
            set (token) {
                this.$store.dispatch('MealPlan/setToken', token)
            },
            get () {
                return this.$store.getters['MealPlan/token']
            }
        },
        ...mapState({
            meals: state => state.nutrition.meals,
            imageUrl: state => state.settings.imageUrl,
            user: state => state.auth.user
        }),
      ...mapGetters({
        meal_tokens: 'MealPlan/meal_tokens',
        snack_tokens: 'MealPlan/snack_tokens',
        meal_plan_items: 'MealPlan/meal_plan_items',
        challengeWeeks: 'challenge/weeks',
        currentWeek: 'challenge/currentWeek',
        realWeek: 'challenge/realWeek',
        currentDay: 'challenge/currentDay',
        realDay: 'challenge/realDay',
        weeks: 'challenge/weeks',
        streams: 'Streams/challengeStreams',
        loading: 'Global/loading',

      }),
      challengeWeek () {
        return this.currentWeek > 0 ? this.currentWeek : 1
      },
      tokenSnacksAvailable () {
        return this.tokens.filter(token => token.type == 'Snack' && token.meal < 1).length
      },
      tokenMealsAvailable () {
        return this.tokens.filter(token => token.type == 'Meal' && token.meal < 1).length
      },
      tokens () {

        var mealTokens = [
          {type: 'Meal', day: 0, meal: 0},
          {type: 'Meal', day: 0, meal: 0},
          {type: 'Snack', day: 0, meal: 0},
          {type: 'Snack', day: 0, meal: 0},
        ]

          let index = 0
          this.meal_tokens.forEach(item => {
              mealTokens[index].item = item
              index++
          })

          index = 2
          this.snack_tokens.forEach(item => {
              mealTokens[index].item = item
              index++
          })

        return mealTokens
      }
    },
    filters: {
      leadingZero: function (value) {
        var s = value + ""
        while (s.length < 2) s = "0" + s
        return s
      },
      dayName: function (day, week, currentDay) {
        day = (week - 1) * 7 + day

        let diff = day - currentDay


        return moment().add(diff, 'days').calendar(moment(), {
          sameDay: '[Today]',
          nextDay: '[Tomorrow]',
          nextWeek: 'dddd',
          lastDay: '[Yesterday]',
          lastWeek: 'dddd',
          sameElse: 'dddd'
        })
      },
      weekName: function (week, current, currentDay) {
        if (current < 1 || currentDay < 0) return 'Week ' + week
        if (week === current) return 'This week'
        if (week - current === -1) return 'Last week'
        if (week - current === 1) return 'Next week'
        return 'Week ' + week
      },
      truncated: (val) => {
        return val.substring(0,1)
      }
    },
    methods: {
      cantClaimToken (meal) {
        if(this.selectedWeek !== this.currentWeek) return true
        return !meal.token && ((!this.isMeal(meal) && this.tokenSnacksAvailable < 1) || (this.isMeal(meal) && this.tokenMealsAvailable < 1))
      },
      disclaimToken (item) {
        this.show_tokens = false
        this.token = {action: 'remove', item}
      },
      claimToken () {
        var meal = this.token.meal
        var action = this.token.action

        this.$store.dispatch('nutrition/updateMealToken', {meal_id: meal.id, action: action})
        this.token = {action: null}
        /*
        var BreakException = {};
        try {
          this.tokens.forEach(token => {
            if (token.type == type && token.day < 1 && token.meal < 1) {
              token.day = day
              token.meal = meal
              throw BreakException
            }
          })
        } catch (e) {
          if (e !== BreakException) throw e;
        }
        */
      },
      isMeal (meal) {
        var meals = ['Breakfast', 'Lunch', 'Dinner', 'Dessert']
        return meals.indexOf(meal.title) >= 0
      },
      isTokenClaimed (day, meal) {
        var meal_index = day.meals.indexOf(meal) + 1
        var result = this.tokens.filter(token => token.day == day.week_day && token.meal == meal_index)
        return result.length > 0
      },
      getTokenDetails (token) {
        if(!token.item && token.item.day) return null
        return this.$options.filters.dayName(token.item.day, 1, this.realDay + 1) + ' ' + token.item.meal_type.title
      },
      goToday () {
          if(this.selectedWeek === this.currentWeek) {
              return this.$vuetify.goTo('.today', {offset: 30 + 83})
          }
        this.selectedWeek = this.currentWeek
          this.goto = true
      }
    },
    data: () => ({
      update_stream: false,
      show_tokens: false,
        goto: false,
      /*
      tokens: [
        {type: 'Meal', day: 0, meal: 0},
        {type: 'Meal', day: 0, meal: 0},
        {type: 'Snack', day: 0, meal: 0},
        {type: 'Snack', day: 0, meal: 0},
      ],
      */
      vegetarian: false,
        mdiTicket,
      /*
      streams: [
              {index: 0, name: 'Meal Plan A'},
              {index: 1, name: 'Meal Plan B'},
              {index: 2, name: 'Meal Plan C'},
              {index: 3, name: 'Vegetarian'},
      ],
      */
      days: [
        { title: 'Monday' },
        { title: 'Tuesday' },
        { title: 'Wednesday' },
        { title: 'Thursday' },
        { title: 'Friday' },
        { title: 'Saturday' },
        { title: 'Sunday' }
      ],
      items: [
        {
          avatar: 'https://loremflickr.com/320/240/breakfast',
          title: 'Breakfast',
          subtitle: [
                  "30g (1/3 cup) rolled oats* cooked as porridge with water, topped with" +
                  "10g (2tsp) mixed seeds, 100g Chobani Greek yoghurt (plain), ½ banana",
                  "30g (1/3 cup) rolled oats* cooked as porridge with water, topped with" +
                 "10g (2tsp) mixed seeds, ½ banana"
          ]
        },
        {
          avatar: 'https://loremflickr.com/320/240/lunch',
          title: 'Lunch',
          subtitle: [
                  "Goodness Superfoods Barley wrap* filled with 95g tin of tuna in oil (drained), spinach, " +
                  "shredded carrot, capsicum, cucumber and 1tsp whole-egg mayo",
                  "Goodness Superfoods Barley wrap* filled with 100g of tofu, spinach, " +
                  "shredded carrot, capsicum, cucumber and 1tsp vinegar"
          ]
        },
        {
          avatar: 'https://loremflickr.com/320/240/dinner',
          title: 'Dinner',
          subtitle: [
                  "Chicken fajitas",
                  "Avocado Salad"
                  ]
        }
      ],
      // selectedWeek: 0
    }),
  }
</script>

<style lang="scss">

  $header-height: 123px;

  .nutrition {

    .headline, .dialog-header {
      color: #24ADBB;
      font-size: 16px !important;
      font-weight: bold;
      text-transform: uppercase;
      width: 100%;
    }

    width: 100%;
    margin-top: $header-height;
    .week-nav {
      h3 {
        margin-top: 5px;
        font-family: 'DIN Alternate Bold';
        font-size: 20px;
        text-transform: uppercase;
      }
    }
    .custom {
      &.v-text-field.v-input--is-focused > .v-input__control > .v-input__slot:after {
        border-style: none !important;
      }
      .v-select__selections {
        justify-content: center;
        input {
          display: none;
        }
      }
      .v-select__selection {
        width: 100%;
        justify-content: center;
        color: #FFFFFF;
        margin: 7px 4px 7px 12px;
      }
      .v-input__append-inner {
        padding-left: 0;
      }

    }
  }

  .week-header {
    height: $header-height;
    background-color: #FFFFFF;
    width: 100%;
    top: 0;
    z-index: 2;
    h2 {
      font-weight: 400;
      padding: 10px;
    }
  }



  h1 {
    margin: 0;
    //padding-left: 10px;
    //padding-top: 10px;
    padding: 5px 10px;
    color: #fff;
    font-weight: 100;
  }

  .content {
    width: 100%;
    height: 100%;
  }

  .content .header {
    width: 100%;
    position: sticky;
    top: $header-height;
    background-color: #24ADBB;
    z-index: 1;
    padding: 5px 0 0;
    height: 30px;
    h3 {
      font-family: 'DIN Alternate Bold';
      color: #FFFFFF;
      font-size: 16px;
      text-align: center;
      text-transform: uppercase;
    }
  }

  .nutritional-info {
    .v-card__text {
      padding: 5px;
      text-align: center;
      color: #5F6369;
      font-size: 10px;
    }
  }


  .token-container {
    height: 30px;
    margin-bottom: 10px;
    .v-btn, .theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
      background-color: #24ADBB !important;
      min-width: 20px;
      .v-icon--right {
        margin-left: 5px;
      }
    }
    .theme--dark.v-btn.v-btn--disabled {
      opacity: .5 !important;
    }
    .v-btn--active, .v-btn--active.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
      background-color: red !important;
      .v-btn__content {
        opacity: .5;
      }
    }

  }

  .v-list-item__title, .v-list-item__subtitle {
    font-size: 12px !important;
  }

  .token-color {
    .theme--light.v-btn.v-btn--disabled & {
      color: #24ADBB !important;
      opacity: .5;
    }
    color: #24ADBB !important;
    &.token-claimed {
      color: red !important;
      .theme--light.v-btn.v-btn--disabled & {
        color: red !important;
      }
    }
  }

</style>
